import React, { useEffect, useState } from 'react';

import { ChatHeader } from './components/ChatHeader';
import { MessageList } from './components/MessageList';
import { MotionFlex } from './components/Motion';
import { Store } from './store';
import { useMessage, useSessionInfo } from '@outdoorly/react-chat-sdk';
import { useDimensions, useIsDesktop } from './utils/dimensions';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { useMemoizedFrame } from './utils/hooks';

export const Chat: React.FC<{}> = React.memo(() => {
  const isClosed = Store.useState((s) => s.activatorVisible);
  const isDesktop = useIsDesktop();
  const isMobile = !isDesktop;

  const { initialized } = useSessionInfo();

  const dims = useDimensions();

  const variants = {
    closed: {
      opacity: 0,
      translateY: 10,
      transitionEnd: {
        display: 'none'
      }
    },
    open: { translateY: 0, opacity: 1, display: 'flex' }
  };
  const { document } = useMemoizedFrame();

  useEffect(() => {
    const scrollableList = document?.getElementById('remark-widget-message-list');
    if (isMobile && !isClosed && scrollableList) {
      disableBodyScroll(scrollableList);
    } else {
      clearAllBodyScrollLocks();
    }
    return () => clearAllBodyScrollLocks();
  }, [isMobile, isClosed, document]);
  return (
    <>
      {!isClosed && (
        <MotionFlex
          direction="column"
          // Put the chat box inside the single grid cell
          gridArea={'a'}
          position="relative"
          variants={variants}
          initial="closed"
          animate={isClosed || !initialized ? 'closed' : 'open'}
          // We also can't use the chakra responsive/breakpoint styles because those are relative to the local parent
          // Rely on tangible dimensions from the browser to dictate size
          // Attempting to be relative to the container won't work
          w={isMobile ? `${dims.width}px` : '376px'}
          minW={isMobile ? `${dims.width}px` : 'unset'}
          h={isMobile ? `${dims.height}px` : '590px'}
          minH={isMobile ? `${dims.height}px` : 'unset'}
          maxH={isMobile ? `${dims.height}px` : `${dims.height - 40}px`}
          borderRadius={isMobile ? 0 : '8px'}
          pointerEvents="all"
          backgroundColor="scheme.backgroundPrimary"
          marginBottom={isMobile ? 0 : '20px'}
          marginRight={isMobile ? 0 : '20px'}
        >
          <ChatHeader />
          <MessageList key="msgList" />
        </MotionFlex>
      )}
    </>
  );
});
